import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import '../styles/Formulario.css';

const FormularioTrabajo = () => {
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    correoElectronico: '',
    telefono: '',
    formacionAcademica: null,
    formacionOtra: '',
    nivelEstudios: '',
    areaInteres: '',
    cv: null,
    mensaje: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const areasInteres = [
    'Administrativo',
    'Docente',
    'Producción + ID',
    'TIC',
    'Comercial',
    'Prácticas preprofesionales',
  ];

  const nivelesEstudio = [
    'Bachillerato',
    'Técnico',
    'Tecnólogo',
    'Licenciatura/Ingeniería (en curso)',
    'Licenciatura/Ingeniería (completa)',
    'Maestría',
    'Doctorado',
  ];

  const opcionesFormacion = [
    { value: 'Electrónica', label: 'Electrónica' },
    { value: 'Mecatrónica', label: 'Mecatrónica' },
    { value: 'Mecánica industrial', label: 'Mecánica industrial' },
    { value: 'Pedagogía en informática/mecatrónica.', label: 'Pedagogía en informática/mecatrónica' },
    { value: 'Educación', label: 'Educación' },
    { value: 'Desarrollo de software', label: 'Desarrollo de software' },
    { value: 'Tecnologías de la información/computación.', label: 'Tecnologías de la información/computación.' },
    { value: 'Administración de empresas.', label: 'Administración de empresas.' },
    { value: 'Contabilidad y auditoria.', label: 'Contabilidad y auditoria.' },
    { value: 'other', label: 'Otro (especificar)' },
  ];

  // Inputs básicos
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(fd => ({ ...fd, [name]: value }));
    if (errors[name]) setErrors(err => ({ ...err, [name]: null }));
  };

  // React‑Select
  const handleFormacionChange = selected => {
    setFormData(fd => ({ ...fd, formacionAcademica: selected, formacionOtra: '' }));
    if (errors.formacionAcademica) setErrors(err => ({ ...err, formacionAcademica: null }));
  };

  // Dropzone
  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length) {
      const error = fileRejections[0].errors[0];
      setErrors(err => ({ ...err, cv: error.message }));
      return;
    }
    setFormData(fd => ({ ...fd, cv: acceptedFiles[0] }));
    setErrors(err => ({ ...err, cv: null }));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'] },
    maxSize: 5 * 1024 * 1024,
  });

  // Validación
  const validateForm = () => {
    const newErr = {};
    if (!formData.nombreCompleto.trim()) newErr.nombreCompleto = 'Obligatorio';
    if (!formData.correoElectronico.trim()) newErr.correoElectronico = 'Obligatorio';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correoElectronico))
      newErr.correoElectronico = 'Email inválido';
    if (!/^[0-9]{10}$/.test(formData.telefono)) newErr.telefono = '10 dígitos';
    if (!formData.formacionAcademica) newErr.formacionAcademica = 'Seleccione o escriba';
    if (formData.formacionAcademica?.value === 'other' && !formData.formacionOtra.trim())
      newErr.formacionOtra = 'Por favor especifique';
    if (!formData.nivelEstudios) newErr.nivelEstudios = 'Seleccione nivel';
    if (!formData.areaInteres) newErr.areaInteres = 'Seleccione área';
    if (!formData.cv) newErr.cv = 'Adjunte CV en PDF';
    return newErr;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErr = validateForm();
    if (Object.keys(newErr).length) {
      setErrors(newErr);
      return;
    }

    console.log('Enviando:', formData);
    setIsSubmitted(true);
    try {
      // Crear FormData para incluir los archivos (CV)
      const formDataToSend = new FormData();
      formDataToSend.append('nombreCompleto', formData.nombreCompleto);
      formDataToSend.append('correoElectronico', formData.correoElectronico);
      formDataToSend.append('telefono', formData.telefono);
      // si eligió “other”, enviamos lo que escribió en formacionOtra
      const valorFormacion =
        formData.formacionAcademica.value === 'other'
          ? formData.formacionOtra.trim()
          : formData.formacionAcademica.value;
      formDataToSend.append('formacionAcademica', valorFormacion);
      // formDataToSend.append('formacionAcademica', formData.formacionAcademica?.value || formData.formacionOtra);
      formDataToSend.append('nivelEstudios', formData.nivelEstudios);
      formDataToSend.append('areaInteres', formData.areaInteres);
      formDataToSend.append('mensaje', formData.mensaje);
      if (formData.cv) formDataToSend.append('cv', formData.cv);

      // Hacer la solicitud POST al backend
     const response = await axios.post(
      'https://trabajaconnosotros.roboticminds.ec/api/trabajo',
        formDataToSend
        );

      if (response.status === 200) {
        // Aquí puedes hacer algo después de que la solicitud sea exitosa (como mostrar un mensaje)
        console.log('Formulario enviado correctamente');
      }
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
    }

    // Restablecer el formulario después de la aplicación
    setFormData({
      nombreCompleto: '',
      correoElectronico: '',
      telefono: '',
      formacionAcademica: null,
      formacionOtra: '',
      nivelEstudios: '',
      areaInteres: '',
      cv: null,
      mensaje: '',
    });
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  return (
    <div className="formulario-container">
      <div className="formulario-header">
        <h1>Trabaja con nosotros</h1>
        <p>Completa el formulario para aplicar a nuestras oportunidades</p>
      </div>

      {isSubmitted ? (
        <div className="success-message">
          <h2>¡Gracias por tu aplicación!</h2>
          <p>Recibimos tu información. Nos pondremos en contacto si encajas.</p>
          <Link to="/" className="volver-button">Volver al inicio</Link>
        </div>
      ) : (
        <form className="trabajo-form" onSubmit={handleSubmit}>
          {/* Nombre */}
          <div className="form-group">
            <label>Nombre completo *</label>
            <input
              name="nombreCompleto"
              value={formData.nombreCompleto}
              onChange={handleChange}
              className={errors.nombreCompleto ? 'error' : ''}
              placeholder="Tu nombre"
            />
            {errors.nombreCompleto && <span className="error-message">{errors.nombreCompleto}</span>}
          </div>

          {/* Correo */}
          <div className="form-group">
            <label>Correo electrónico *</label>
            <input
              type="email"
              name="correoElectronico"
              value={formData.correoElectronico}
              onChange={handleChange}
              className={errors.correoElectronico ? 'error' : ''}
              placeholder="email@dominio.com"
            />
            {errors.correoElectronico && <span className="error-message">{errors.correoElectronico}</span>}
          </div>

          {/* Teléfono */}
          <div className="form-group">
            <label>Teléfono *</label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              className={errors.telefono ? 'error' : ''}
              placeholder="10 dígitos"
            />
            {errors.telefono && <span className="error-message">{errors.telefono}</span>}
          </div>

          {/* Formación académica */}
          <div className="form-group">
            <label>Formación académica *</label>
            <CreatableSelect
              options={opcionesFormacion}
              value={formData.formacionAcademica}
              onChange={handleFormacionChange}
              placeholder="Buscar o escribir..."
              formatCreateLabel={v => `Crear: "${v}"`}
              className={errors.formacionAcademica ? 'react-select-error' : ''}
            />
            {formData.formacionAcademica?.value === 'other' && (
              <input
                type="text"
                name="formacionOtra"
                placeholder="Especifique su profesión"
                value={formData.formacionOtra}
                onChange={handleChange}
                className={errors.formacionOtra ? 'error' : ''}
                style={{ marginTop: '10px' }}
              />
            )}
            {errors.formacionAcademica && (
              <span className="error-message">{errors.formacionAcademica}</span>
            )}
            {errors.formacionOtra && (
              <span className="error-message">{errors.formacionOtra}</span>
            )}
          </div>

          {/* Nivel de estudios */}
          <div className="form-group">
            <label>Nivel de estudios alcanzado *</label>
            <select
              name="nivelEstudios"
              value={formData.nivelEstudios}
              onChange={handleChange}
              className={errors.nivelEstudios ? 'error' : ''}
            >
              <option value="">Seleccione nivel</option>
              {nivelesEstudio.map((n, i) => (
                <option key={i} value={n}>{n}</option>
              ))}
            </select>
            {errors.nivelEstudios && <span className="error-message">{errors.nivelEstudios}</span>}
          </div>

          {/* Área de interés */}
          <div className="form-group">
            <label>Área de interés *</label>
            <select
              name="areaInteres"
              value={formData.areaInteres}
              onChange={handleChange}
              className={errors.areaInteres ? 'error' : ''}
            >
              <option value="">Seleccione área</option>
              {areasInteres.map((a, i) => (
                <option key={i} value={a}>{a}</option>
              ))}
            </select>
            {errors.areaInteres && <span className="error-message">{errors.areaInteres}</span>}
          </div>

          {/* Hoja de vida */}
          <div className="form-group">
            <label>Hoja de vida (PDF) *</label>
            <div {...getRootProps()} className={`dropzone ${errors.cv ? 'error' : ''}`}>
              <input {...getInputProps()} />
              {isDragActive
                ? <p>Suelta el PDF aquí…</p>
                : <p>Arrastra tu CV o haz clic para seleccionar</p>}
            </div>
            {formData.cv && <p className="file-name">{formData.cv.name}</p>}
            {errors.cv && <span className="error-message">{errors.cv}</span>}
            <small>Tamaño máximo: 5MB</small>
          </div>

          {/* Mensaje */}
          <div className="form-group">
            <label>Mensaje adicional (opcional)</label>
            <textarea
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChange}
              rows="4"
              placeholder="Algo más que quieras contarnos…"
            />
          </div>

          {/* Acciones */}
          <div className="form-actions">
            <button type="submit" className="submit-button">Enviar aplicación</button>
            <Link to="/" className="cancel-button">Cancelar</Link>
          </div>
        </form>
      )}
    </div>
  );
};

export default FormularioTrabajo;
